import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleAPIError } from '../utility/actionHelper'
import { serialize, deserialize } from '../utility/serialization'

import Axios from '../axios'

export const updateSeriesEnrollment = createAsyncThunk(
  'nineHoleEvent/updateSeriesEnrollment',
  async (enrollment, { rejectWithValue }) => {
    try {
      const { data } = await requestUpdateSeriesEnrollment(enrollment)
      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const confirmAttendance = createAsyncThunk(
  'studentDashboard/confirmAttendance',
  async (enrollment, { rejectWithValue }) => {
    try {
      await requestConfirmAttendance(enrollment)
      return enrollment
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

function requestUpdateSeriesEnrollment(enrollment) {
  const requestUrl = `/api/v1/series_enrollments/${enrollment.id}`
  const data = serialize(enrollment)

  return Axios.put(requestUrl, data)
}

function requestConfirmAttendance(enrollment) {
  const requestUrl = `/api/v1/series_enrollments/${enrollment.id}/confirm_attendance`
  const data = serialize(enrollment)

  return Axios.post(requestUrl, data)
}
